mutation CreateWorkspace(
  $name: String!
  $organizationType: OrganizationType
  $pricingPlan: PricingPlanType!
  $timezone: String!
  $workspaceType: WorkspaceType
) {
  createWorkspace(
    name: $name
    organizationType: $organizationType
    pricingPlan: $pricingPlan
    timezone: $timezone
    workspaceType: $workspaceType
  ) {
    id
  }
}
